/**
 * AdHalfPopup - 广告半弹窗组件（基于Popup派生）
 * 底部半弹窗广告，展示运营系统配置的弹窗图片
 */
import classNames from 'classnames';
import React from 'react';
import Popup, { PopupProps } from '../Popup';

import './index.scss';

export interface AdHalfPopupProps extends Omit<PopupProps, 'children'> {
  imageUrl: string;
}

export const AdHalfPopup: React.FC<AdHalfPopupProps> = ({
  visible,
  imageUrl,
  onClose,
  maskClosable = false,
  showClose = true,
  className,
}) => (
  <Popup
    visible={visible}
    onClose={onClose}
    maskClosable={maskClosable}
    showClose={showClose}
    className={classNames('hy-ad-half-popup', className)}
  >
    <img className='hy-ad-half-popup__image' src={imageUrl} />
  </Popup>
);

export default AdHalfPopup;
